import {
  Button,
  Dropdown,
  DropdownMenu,
  type DropdownMenuItem,
  ProfileIcon,
} from "@bp/ui-components";
import { useAuth } from "react-oidc-context";
import { useAuthClaims } from "../../hooks/useAuthClaims";

/**
 * Account control, modelled on planung-frontend's header profile: a tertiary
 * DS `Button` (ProfileIcon + the signed-in name) as the trigger. Since the admin
 * app has no profile page, it opens a minimal DS `DropdownMenu` with just
 * "Abmelden" (no audit-log entry).
 */
export function AgentMenu() {
  const { pimAuthClaims } = useAuthClaims();
  const profile = pimAuthClaims.getProfile();
  const name = (
    profile.displayName || `${profile.firstName ?? ""} ${profile.lastName ?? ""}`
  ).trim();
  const auth = useAuth();

  const items: DropdownMenuItem[] = [
    { label: "Abmelden", onClick: () => void auth.signoutRedirect() },
  ];

  return (
    <Dropdown
      trigger={
        <Button hierarchy="tertiary" icon={<ProfileIcon />} ariaLabel="Konto-Menü">
          {name}
        </Button>
      }
    >
      <DropdownMenu data={items} />
    </Dropdown>
  );
}
